import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { GetBonusesShema } from "../../Bonuses/redux/actions";

export const getWebhooks = createAsyncThunk(
  "webhooks/getWebhooks",
  async ({ page, limit }: GetBonusesShema) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/operator/get-notifications?limit=${limit}&page=${page}`,
      {
        headers: {
          Authorization: "Bearer " + Cookies.get("token"),
        },
      }
    );
    return data;
  }
);
